import {
  StatisticsSearchAgreedVolumeByFilterOptions,
  UseAgreedVolumeListQuery,
  UseAgreedVolumeListQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";

const query = gql`
  fragment AgreedVolumeListItems on StatisticsByAgreedVolumeListItem {
    statNumber
    statCustomerIndex
    routePairCode
    agreedVolume
    shippedVolume
    performanceInPercent
  }

  query UseAgreedVolumeList(
    $filterOptions: StatisticsSearchAgreedVolumeByFilterOptions!
  ) {
    statistics {
      agreedVolumeList {
        byFilter(filterOptions: $filterOptions) {
          items {
            ...AgreedVolumeListItems
          }
        }
      }
    }
  }
`;

export const useAgreedVolumeListQuery = () => {
  const [fetchAgreedVolumeList, { error, loading, data }] = useLazyQuery<
    UseAgreedVolumeListQuery,
    UseAgreedVolumeListQueryVariables
  >(query, {
    fetchPolicy: "network-only",
  });

  return {
    error,
    loading,
    agreedVolumeItems: data?.statistics.agreedVolumeList.byFilter?.items,
    fetchAgreedVolumeList,
  };
};
